import { render, staticRenderFns } from "./MenuDown.vue?vue&type=template&id=23154a4d&functional=true&"
import script from "./MenuDown.vue?vue&type=script&lang=js&"
export * from "./MenuDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cookbook/cookbook/cookbook/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23154a4d')) {
      api.createRecord('23154a4d', component.options)
    } else {
      api.rerender('23154a4d', component.options)
    }
    module.hot.accept("./MenuDown.vue?vue&type=template&id=23154a4d&functional=true&", function () {
      api.rerender('23154a4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/MenuDown.vue"
export default component.exports